import { ICSVFormat } from "../models/csv_format";
import Encoding from "encoding-japanese";
import Papa from "papaparse";

export const importCSV = (file: File): Promise<ICSVFormat[]> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        const arrayBuffer = e.target?.result as ArrayBuffer;
        const unicodeString = convertFromSJIS(arrayBuffer);
        const data = parseCSV(unicodeString);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    };
    reader.onerror = () => {
      reject(new Error("CSVファイル読み込み失敗"));
    };
    reader.readAsArrayBuffer(file);
  });
};

export const parseCSV = (text: string): ICSVFormat[] => {
  const results = Papa.parse<ICSVFormat>(text, {
    header: true,
    skipEmptyLines: true,
    dynamicTyping: true,
  });
  return results.data;
};

export const convertFromSJIS = (arrayBuffer: ArrayBuffer): string => {
  const uint8Array = new Uint8Array(arrayBuffer);
  return Encoding.convert(uint8Array, {
    to: "UNICODE",
    from: "SJIS",
    type: "string",
  });
};
